import styled from 'styled-components';
import { Upload as AntdUpload } from 'antd';

export const Upload = styled(AntdUpload)``;
